export default __webpack_public_path__ + "static/express_1-45552e343e338b12370c9161e2a0e1ab.png";